
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFacebookSquare, faInstagramSquare, faLinkedin, faTwitterSquare, faYoutubeSquare, faSquareXTwitter } from '@fortawesome/free-brands-svg-icons';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'site-footer',
  standalone: true,
  imports: [TranslateModule, FontAwesomeModule, RouterModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  faYoutubeSquare = faYoutubeSquare;
  faLinkedin = faLinkedin;
  faInstagramSquare = faInstagramSquare;
  faTwitterSquare = faSquareXTwitter;
  faFacebookSquare = faFacebookSquare;
}
